import type { FC } from 'react';

import { useRecoilValue } from 'recoil';

import * as S from './elements';
import { showGlobalOverlayAtom } from './state';

type Props = {
  isOnline: boolean;
  allowOfflineInteraction: boolean;
};

export const GlobalOverlay: FC<Props> = ({
  isOnline,
  allowOfflineInteraction,
}) => {
  const showOverlay = useRecoilValue<boolean>(showGlobalOverlayAtom);
  const visible = showOverlay || (!isOnline && !allowOfflineInteraction);

  return (
    <S.GlobalOverlay
      data-testid="offline-mode-global-overlay"
      visible={visible}
      onTouchEnd={(e) => e.stopPropagation()}
    />
  );
};
